import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "~/api-routes";
import apiService from "~/services/service";

const initialState = {
  status: "",
  activeIndex: 0,
  nextBtnEnable: false,
  isLeaveModal: false,
  isDataAvailable: false,
  personalInformation: {
    given_name: "",
    other_name: "",
    last_name: "",
    preferred_name: "",
    tax_identification_no: "",
    national_id: "",
    social_security_number: "",
    personal_email: "",
    work_email: "",
    phone_code: "",
    phone: "",
    marital_status: "",
  },
  address: {
    country: "",
    address_line_1: "",
    address_line_2: "",
    state: "",
    city: "",
    postalcode: "",
  },
  employmentInformation: {
    employee_identifier: "",
    start_date: null,
    end_date: null,
    employment_type: "",
    employment_status: "",
    job_title: "",
    cost_center: "",
    currency: "",
    salary: "",
    compensation_type: "",
  },
  bankInformation: {
    bank_account_holder_name: "",
    bank_name: "",
    bank_account_number: "",
    bank_swift_bic: "",
    bank_account_currency: "",
    bank_branch_address: "",
    bank_country: "",
  },
  statesarray: [],
  cityarray: [],
  employeeDetails: null,
};
export const getEmployeeDetails = createAsyncThunk(
  "employeeregister/getEmployeeDetails",
  async (id) => {
    return await apiService(API_ROUTES.FETCH_EMPLOYEE, "GET", {
      replace: { id },
    });
  },
);

export const updateEmployee = createAsyncThunk(
  "employeeregister/updateEmployee",
  async ({ id, data }) => {
    return await apiService(API_ROUTES.UPDATE_EMPLOYEE, "PUT", {
      replace: { id },
      body: JSON.stringify(data),
    });
  },
);

const employeeSlice = createSlice({
  name: "employeeregister",
  initialState,
  reducers: {
    setEmployeeData: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
    resetEmployeeData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeeDetails.pending, (state) => {
        state.employeeDetails = null;
      })
      .addCase(getEmployeeDetails.fulfilled, (state, { payload }) => {
        state.employeeDetails = payload.data;
      })
      .addCase(getEmployeeDetails.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export const { setEmployeeData, resetEmployeeData } = employeeSlice.actions;
export default employeeSlice.reducer;
